import api from "@/composables/api";
import { useUser } from "@/stores";

export default () => {
  const userStore = useUser();

  //TODO: show error if connect fails
  const connectQb = () => {
    api(`v1/qb/connect`)
      .then((res) => {
        const { authUrl } = res.data;
        userStore.activeTab = "";
        window.location.href = authUrl;
      })
      .catch((err) => {
        // console.log("err", err);
      });
  };

  //TODO: show error if disconnect fails
  const disconnectQb = () => {
    api(`v1/qb/disconnect`)
      .then((res) => {
        userStore.setSettings(res.data.userSettings);
      })
      .catch((err) => {
        // console.log("err", err);
      });
  };

  const chargeQb = async (data) => {
    try {
      const res = await api(`v1/qb/charge`, {
        method: "POST",
        body: data,
      });
      // console.log("qb charge res", res);
      return res;
    } catch (err) {
      // console.log("qb charge err", err);
      return err;
    }
  };

  return {
    connectQb,
    disconnectQb,
    chargeQb,
  };
};
